import React from "react";
import './citizen.css'


function Citizen() {
    return (
 <div>
        <div className="heading">
        <h3 > Citizen Charter</h3>
    </div>
        <div className="citizen-container">
           
            <div className="contentt-container">
                <p>Survey of India, under the Ministry of Science and Technology, Government of India, is the national survey
                    and mapping organization and has mandate to take a leadership role in liberalizing access of spatial data to
                    user groups without compromising with the national security.</p>
                <p>The responsibility for producing, maintaining and disseminating the topographic map database of the whole
                    country, which is the foundation of all spatial data vests with survey of India (SOI) . </p>
                <p>In order to improve the delivery of our services, Survey of India has decided to formulate this Citizens’
                    Charter. </p>
                <p>This Charter is the declaration of our vision, values and standards to achieve excellence in the formulation
                    and implementation of National Map Policy for the benefit of Public, Govt./Private organizations and other
                    stakeholders.</p>
                <p> This Citizens’ Charter will also be the benchmark to determine our efficiency and would be a dynamic
                    document, which would be reviewed at least once in five years. </p><br/>
                    <h4>OUR STRATEGY</h4>
                    <p>This strategy for achieving our mission shall comprise the following:</p>
                    <ul>
                        <li>Benchmarking of products/data </li>
                        <li>Enhancing the use of information technology. </li>
                        <li>Measuring conformance to service delivery standards. </li>
                        <li>Evolving cooperative initiatives with other government and private agencies.</li>
                    </ul> <br/>
                        <h4>OUR CLIENTS </h4>
                        <p>Government and private organizations as well as private individuals associated with defence/security,
                            information technology, education and research, navigation, tourism, disaster management, engineering and
                            production, environment, mining, drilling, development, agriculture, fishing, utilities etc. </p><br/>

                            <h4>OUR EXPECTATIONS </h4>
                            <p>We expect citizens to: </p>
                            <ul>
                                <li>Uphold and respect the rules and regulations governing the geospatial data dissemination. </li>
                                <li>Fulfil their duties and legal obligations in time. </li>
                                <li>Be honest in furnishing information. </li>
                                <li>Be co-operative and forthright in inquiries and verifications.</li>
                                <li>Avoid unnecessary litigation. </li>
                                <p>This will enable us to serve the nation in an effective and efficient manner. </p>
                            </ul>



            </div>
        </div>
        </div>
       
       
    )
    }
                    
                    export default Citizen    